import React from 'react'
import { Flex } from '@sendoutcards/quantum-design-ui'

import { useCallback } from 'src/hooks'
import { CommunicationPreferences } from 'src/dashboard/components'
import { AccountInfoSettingsView } from 'src/dashboard/containers/Views/Information/AccountInfoSettingsView'
import { useUpdateAccountSettings } from 'src/react_query'
import { AccountSettingsInput } from 'src/graphql/generated/graphql'
import { UiCard } from 'src/chrome'

export const DashboardSettings: React.FC = () => {
  const updateAccountSettingsMutation = useUpdateAccountSettings()
  const handleUpdateSetting = useCallback(
    async <
      SettingName extends keyof Omit<
        AccountSettingsInput,
        'defaultBackPanelId'
      >,
    >(
      settingName: SettingName,
      value: boolean | number,
    ) => {
      updateAccountSettingsMutation.mutate({
        [settingName]: value,
      })
    },
    [updateAccountSettingsMutation],
  )

  return (
    <Flex
      style={{
        width: '100%',
        maxWidth: '1420px',
        margin: '0 auto',
        padding: '0 16px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
        gap: '24px',
        alignItems: 'start',
      }}
    >
      <Flex flexDirection="column">
        <UiCard
          style={{
            width: '100%',
            maxWidth: '100%',
            padding: 0,
            borderRadius: 24,
            border: '1px solid #eef0f2',
            boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.08)',
            overflow: 'hidden',
          }}
        >
          <AccountInfoSettingsView />
        </UiCard>
      </Flex>
      <Flex flexDirection="column">
        <CommunicationPreferences onToggle={handleUpdateSetting} />
      </Flex>
    </Flex>
  )
}
